<template>
  <div class="footer">
    <div class="m-container">
      <div class="row the-footer">
        <div class="col-6 col-sm-4 col-xs-4 socaial">
          <i class="fab fa-twitter" @click="redirectTo($store.state.settings_website[0].twitter)"></i>
          <i class="fab fa-facebook-f" @click="redirectTo($store.state.settings_website[0].facebook)"></i>
          <!-- <i class="fab fa-telegram" @click="redirectTo($store.state.settings_website[0].telegram)"></i>           -->
          <i class="fab fa-instagram" @click="redirectTo($store.state.settings_website[0].instagram)"></i>
          <i class="fab fa-linkedin-in" @click="redirectTo('')"></i>
        </div>
        <div class="col-6 col-sm-4 col-xs-4 the-logo">
          <img width="100" src="@/assets/img/logo/logo_h_2.png">
        </div>
        <div class="col-12 col-sm-4 col-xs-4 copyright">
          <p>
            Copyright 2021 © WRO Virtual .
          </p>
        </div>
        
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    redirectTo(link){
      if(link === null) {
        return false
      }else {
        window.open(link,'_blank');
      }
    }
  },
}
</script>
<style>

.footer{
  background: var(--mainColors);
  padding: 18px 0;
}

.footer .m-container{
  height: 100%;
}

.footer .the-footer{
  height: 100%;
  align-content: center;
  align-items: center;
  color: #fff;
  font-weight: 500;
}

.footer .the-footer .copyright{
  text-align: right;
  font-size: 12px; 
}

.footer .the-footer .the-logo{
  text-align: center;  
  height: 40px;
}

.footer .the-footer .socaial i{
  margin-right: 27px;
  font-weight: 400;
  font-size: 1.125rem;
  cursor: pointer;
}

@media (max-width: 595px) {
  .footer .the-footer .socaial i{margin-right: 27px;}
  .footer .the-footer .the-logo { text-align: right;}
  .footer .the-footer .copyright{ margin-top: 10px;}
  .footer .the-footer .copyright p{ text-align: center; font-size: 12px;}
  
}
</style>